<template>

  <div :class="{purchases:true, admin: isAdmin}" v-if="ok2go">

		<p v-if="breakdown.length===0">You have no Analysis Credits at the moment.</p>

		<div 
			:class="{purchase:true}"
			v-for="(analysisCredit,index) in breakdown" 
			:key="'purchase-'+index" 
		>

			<h3 :class="{credits:true,not1:analysisCredit.credits!=='1'}">{{analysisCredit.credits}}</h3>

			<h4 :class="purchaseTypeClasses(analysisCredit.method)" v-html="purchaseTypeLabel(analysisCredit)" @click="adminDelete(analysisCredit._id)" />

			<h5 class="expires" v-html="expires(analysisCredit.expires)" />

		</div>

	</div>

</template>

<script>
import general from './../utils/general'
export default {
	name: 'AnalysisCreditsPurchases',
	components: {},
	props: {
		totals: {
			type: Object
		},
		isAdmin: {
			type: Boolean,
			default: false
		}
	},
	data() {

		return {}

	},
	computed: {

		breakdown () {

			return this.totals.breakdown ? this.totals.breakdown : [];

		},

		ok2go () {

			return Object.keys( this.totals ).length > 0;

		}

	},
	methods: {
		
		purchaseTypeClasses (method) {

			let c = { type: true };

			c[method] = true;

			return c;

		},

		purchaseTypeLabel (info) {

			switch (info.method) {

				case 'free' :
					return "Free Credits";
				case 'subscription' :
					return "Monthly Subscription";
				case 'one_time' :
					return "One-off Purchase";
				case 'manually' :
					return this.isAdmin ? "Manual - DELETE" : "Gifted Credits";

			}

		},

		expires (theDate) {

			let n = new Date().getTime() / 1000, 
				t = new Date(theDate).getTime() / 1000,
				hour = 60 * 60,
				day = 24 * hour,
				tt = t - n;

			if ( tt > day ) return 'Expires: ' + general.dateFormat ('jS M Y',theDate);

			if ( tt < hour ) return 'Expires: ' + Math.round(tt / 60) + ' minutes';

			return 'Expires: Today @ ' + general.dateFormat ('H:i',theDate);

		},

		adminDelete (_id) {

			if ( this.isAdmin ) {

				this.$dialog
					.confirm( "Delete these credits?", { okText: 'Yes please', cancelText: 'Cancel',})
					.then(function() {

						this.$emit('deleteCredits',_id);

					}.bind(this))
					.catch(function() {
						

					});

			}

		}

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.purchases {

	.purchase {

		display: inline-block;
		background-color: #fff;
		.rounded(10px);
		padding: 12px;
		margin: 0 15px 15px 0;
		min-width: 170px;

		.credits {

			font-size: 1.5em;
			font-weight: @bold;
			background-color: @formDefaultColour;
			color: #fff;
			.rounded(5px);
			text-align: center;
			position: relative;
			display: inline-block;
			padding: 0 6px;
			min-width: 56px;

			&:after {
				content: "Credits Remaining";
				position: absolute;
				display: block;
				color: @darkContrast;
				.font-standard;
				font-weight: normal;
				text-align: left;
				left: 100%;
				font-size: 0.5em;
				top: 4px;
				line-height: 1.1em;
				padding-left: 6px;
			}

			&.not1 {
				&:after {

					content: "Credits Remaining";

				}
			}

		}

		.type {

			margin-top: 8px;

		}

		.type, .expires {

			text-align: center;
			font-size: 14px;
			padding: 0 4px;

			&.monthly, &.subscription {

				color: @formDefaultColour;

			}

		}

		.expires {

			font-weight: normal;
			border-top: 1px solid @darkContrast;
			margin-top: 2px;
			padding-top: 2px;

		}

	}

	&.admin {

		.purchase {

			.type {

				&.manually {

					cursor: pointer;

					&:hover {

						color: @red;

					}

				}

			}

		}


	}

}
@media screen and (min-width: 768px) {
	.purchases {

		&:not(.admin) {

			margin-top: 30px;

		}

	}
}
</style>